import { useCallback, useState } from 'react'
import Project from 'common/project'
import _data from 'common/utils/_data'

interface Article {
  id: string
  title: string
  url: string
}

export const useGetOurStoryArticles = () => {
  const [articles, setArticles] = useState<Article[]>([])
  const [page, setPage] = useState(1)
  const [isLoadMore, setIsLoadMore] = useState(false)

  const getArticles = useCallback(
    async (pageSize = 3) => {
      try {
        const response = await _data.get(
          `${Project.liveApi}website/our-story-articles/?page=${page}&page_size=${pageSize}`,
        )

        if (response.next !== null) {
          setPage((prevPage) => prevPage + 1)
          setIsLoadMore(true)
        } else {
          setIsLoadMore(false)
        }

        setArticles((prevArticles) => [...prevArticles, ...response.results])
      } catch (error) {
        console.error('Error fetching articles:', error)
      }
    },
    [page],
  )

  return {
    getArticles,
    articles,
    isLoadMore,
  }
}
